import {createReducer, on} from '@ngrx/store';
import {datevWizardClientIdStateInitial} from './datev-wizard-client-id.state.initial';
import {DatevWizardClientIdActions} from './datev-wizard-client-id.actions';


export const datevWizardClientIdReducers = createReducer(
  datevWizardClientIdStateInitial,

  on(
    DatevWizardClientIdActions.setClientId,
    (state, {firmenId, clientId}) => ({
      ...state,
      clientId,
      existingExportConfig: undefined,
      checkConfigLoaded: state.checkConfigLoaded.filter(key => !key.startsWith(`${firmenId}:`)),
      checkConfigLoading: state.checkConfigLoading.filter(key => !key.startsWith(`${firmenId}:`)),
    }),
  ),

  on(
    DatevWizardClientIdActions.syncClientIdFromRoute,
    (state, {clientId}) => ({
      ...state,
      clientId,
    }),
  ),

  on(
    DatevWizardClientIdActions.checkIfConfigExists,
    (state, {firmenId, clientId}) => {
      const key = `${firmenId}:${clientId}`;
      return {
        ...state,
        checkConfigLoading: state.checkConfigLoading.includes(key)
          ? state.checkConfigLoading
          : [...state.checkConfigLoading, key],
      };
    },
  ),

  on(
    DatevWizardClientIdActions.checkIfConfigExistsSuccess,
    (state, {firmenId, clientId, loginUrl}) => {
      const key = `${firmenId}:${clientId}`;
      return {
        ...state,
        checkConfigLoading: state.checkConfigLoading.filter(k => k !== key),
        checkConfigLoaded: state.checkConfigLoaded.includes(key)
          ? state.checkConfigLoaded
          : [...state.checkConfigLoaded, key],
        existingExportConfigExists: false,
        existingExportConfigError: false,
        checkConfigSuccessLoginUrl: loginUrl,
      };
    },
  ),

  on(
    DatevWizardClientIdActions.checkIfConfigExistsFailure,
    (state, {firmenId, clientId}) => {
      const key = `${firmenId}:${clientId}`;
      return {
        ...state,
        checkConfigLoading: state.checkConfigLoading.filter(k => k !== key),
        checkConfigLoaded: state.checkConfigLoaded.includes(key)
          ? state.checkConfigLoaded
          : [...state.checkConfigLoaded, key],
        existingExportConfigError: true,
        existingExportConfigExists: false,
      };
    },
  ),

  on(
    DatevWizardClientIdActions.checkIfConfigExistsWithConflict,
    (state, {firmenId, clientId}) => {
      const key = `${firmenId}:${clientId}`;
      return {
        ...state,
        checkConfigLoading: state.checkConfigLoading.filter(k => k !== key),
        checkConfigLoaded: state.checkConfigLoaded.includes(key)
          ? state.checkConfigLoaded
          : [...state.checkConfigLoaded, key],
        existingExportConfigExists: true,
        existingExportConfigError: false,
      };
    },
  ),

  // getExistingExportConfig Loading/Loaded States
  on(
    DatevWizardClientIdActions.getExistingExportConfig,
    (state, {exportConfigId}) => {
      if (!exportConfigId) return state;
      return {
        ...state,
        existingExportConfigLoading: state.existingExportConfigLoading.includes(exportConfigId)
          ? state.existingExportConfigLoading
          : [...state.existingExportConfigLoading, exportConfigId],
        existingExportConfigError: false,
        existingExportConfigExists: false,
      };
    },
  ),

  on(
    DatevWizardClientIdActions.getExistingExportConfigSuccess,
    (state, {existingExportConfig}) => {
      const exportConfigId = existingExportConfig.id;
      if (!exportConfigId) return state;
      return {
        ...state,
        existingExportConfig,
        existingExportConfigLoading: state.existingExportConfigLoading.filter(id => id !== exportConfigId),
        existingExportConfigLoaded: state.existingExportConfigLoaded.includes(exportConfigId)
          ? state.existingExportConfigLoaded
          : [...state.existingExportConfigLoaded, exportConfigId],
        existingExportConfigExists: true,
        existingExportConfigError: false,
        existingExportConfigErrorStatus: undefined,
      };
    },
  ),

  on(
    DatevWizardClientIdActions.getExistingExportConfigFailure,
    (state, {exportConfigId, error}) => {
      if (!exportConfigId) return state;

      return {
        ...state,
        existingExportConfigLoading: state.existingExportConfigLoading.filter(id => id !== exportConfigId),
        existingExportConfigLoaded: state.existingExportConfigLoaded.includes(exportConfigId)
          ? state.existingExportConfigLoaded
          : [...state.existingExportConfigLoaded, exportConfigId],
        existingExportConfigExists: false,
        existingExportConfigError: true,
        existingExportConfigErrorStatus: error?.status,
      };
    },
  ),

  on(
    DatevWizardClientIdActions.setExistingExportConfig,
    (state, {existingExportConfig}) => ({
      ...state,
      clientId: existingExportConfig.datevClientId,
      existingExportConfig,
    }),
  ),

  // getExistingExportConfigStatus Loading/Loaded States
  on(
    DatevWizardClientIdActions.getExistingExportConfigStatus,
    (state, {exportConfigId}) => {
      if (!exportConfigId) return state;
      return {
        ...state,
        existingExportConfigStatusLoading: state.existingExportConfigStatusLoading.includes(exportConfigId)
          ? state.existingExportConfigStatusLoading
          : [...state.existingExportConfigStatusLoading, exportConfigId],
      };
    },
  ),

  on(
    DatevWizardClientIdActions.getExistingExportConfigStatusSuccess,
    (state, {existingExportConfigStatus}) => {
      const exportConfigId = existingExportConfigStatus.id;
      if (!exportConfigId) return state;
      return {
        ...state,
        existingExportConfigStatusLoading: state.existingExportConfigStatusLoading.filter(id => id !== exportConfigId),
        existingExportConfigStatusLoaded: state.existingExportConfigStatusLoaded.includes(exportConfigId)
          ? state.existingExportConfigStatusLoaded
          : [...state.existingExportConfigStatusLoaded, exportConfigId],
        existingExportConfigStatusError: false,
      };
    },
  ),

  on(
    DatevWizardClientIdActions.getExistingExportConfigStatusFailure,
    (state, {exportConfigId}) => {
      if (!exportConfigId) return state;
      return {
        ...state,
        existingExportConfigStatusLoading: state.existingExportConfigStatusLoading.filter(id => id !== exportConfigId),
        existingExportConfigStatusLoaded: state.existingExportConfigStatusLoaded.includes(exportConfigId)
          ? state.existingExportConfigStatusLoaded
          : [...state.existingExportConfigStatusLoaded, exportConfigId],
        existingExportConfigStatusError: true,
      };
    },
  ),

  on(
    DatevWizardClientIdActions.setExistingExportConfigStatus,
    (state, {existingExportConfigStatus}) => ({
      ...state,
      existingExportConfigStatus,
    }),
  ),

  on(
    DatevWizardClientIdActions.resetExistingConfig,
    (state) => ({
      ...datevWizardClientIdStateInitial,
      clientId: state.clientId,
    }),
  ),

  on(
    DatevWizardClientIdActions.updateExportConfigStatusAfterDisconnect,
    (state) => {
      if (!state.existingExportConfigStatus) {
        return state;
      }
      return {
        ...state,
        existingExportConfigStatus: {
          ...state.existingExportConfigStatus,
          connection: false,
          datevClientName: undefined,
          expiration: undefined,
          owner: undefined,
        },
      };
    },
  ),
);
